module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8003.420a7df6.png";